import { jsonRequest } from "./api.request";

export const fetchCreateApplication = ({ ...body }) =>
  jsonRequest(
    `${window.config.baseUrlForApi}/v1/Application`,
    false,
    { ...body },
    "POST"
  );
